import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { memo } from 'react';
import { FlexContainer } from '../../../CSS/index.js';
const MIN_HEIGHT = 'calc(100vh - 100px - 60px)';
const BACKGROUND = '#fafbfc';
const AppWrapper = memo(({ children, ...props }) => {
    const { minHeight = MIN_HEIGHT, background = BACKGROUND } = props;
    return (_jsx(FlexContainer, { style: {
            minHeight,
            background,
            position: 'relative',
            flexDirection: 'column'
        }, children: children }));
});
export default AppWrapper;
//# sourceMappingURL=index.js.map